import React from "react";

const TruckwiseIncomeVsExpenses = () => {
  return <div>TruckwiseIncomeVsExpenses</div>;
};

export default TruckwiseIncomeVsExpenses;
